const configuredLocale = String(process.env.VUE_APP_DEFAULT_LANG || 'en').toLowerCase()

export const DEFAULT_LOCALE = ['cn', 'pt'].includes(configuredLocale)
  ? configuredLocale
  : 'en'

export const DEFAULT_PHONE_CODE = {
  cn: '86',
  pt: '55',
  en: '1'
}[DEFAULT_LOCALE]
